import { render } from "./Dictionary.vue?vue&type=template&id=1d37dbe2&scoped=true"
import script from "./Dictionary.vue?vue&type=script&lang=js"
export * from "./Dictionary.vue?vue&type=script&lang=js"

import "./Dictionary.vue?vue&type=style&index=0&id=1d37dbe2&scoped=true&lang=scss"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d37dbe2"]])

export default __exports__